import { __awaiter } from "tslib";
import services from '@/services';
const namespaced = true;
class Screener {
    constructor() {
        this.isAccessesScreener = false;
    }
}
const mutations = {
    setAccessesScreener(state, payload) {
        state.isAccessesScreener = payload;
    }
};
const actions = {
    actionAccessesScreener({ commit }, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { status } = yield services.screener.access();
            if (status === 200) {
                commit('setAccessesScreener', true);
            }
            else {
                commit('setAccessesScreener', false);
            }
        });
    }
};
const getters = {
    getAccessesScreener: (state) => state.isAccessesScreener
};
export default {
    namespaced,
    state: new Screener(),
    mutations,
    actions,
    getters
};
